import { jsx as _jsx } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { ArticleSection } from "../../components/ArticleSection/ArticleSection";
import { Layout } from "../../components/Layout";
function ArticlePage(param) {
    var article = param.article;
    return /*#__PURE__*/ _jsx(Layout, {
        title: article.title,
        children: /*#__PURE__*/ _jsx(ArticleSection, {
            article: article
        })
    });
}
export var __N_SSG = true;
export default _withSuperJSONPage(ArticlePage);
